import makeStyles from "@mui/styles/makeStyles";
import { colorSystem } from "../../../theme";

export const accordionStyles = makeStyles((theme) => ({
  accordionRoot: {
    "&.MuiPaper-root": {
      boxShadow: `0px 4px 4px 0px ${colorSystem.shadow1}`,
      border: `1px solid ${colorSystem.grayAlpha33}`,
      borderRadius: "12px",
      marginBottom: `${theme.spacing(3)} !important`,
    },
  },
}));
